<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="章节">
<!--                  <el-input  v-model="queryForm.charpterId"></el-input>-->
                  <el-select
                      clearable
                      style="width: 177px"
                      v-model="queryForm.charpterId"
                      placeholder="请选择"
                      size="small"
                  >
                      <el-tree
                          :data="eduCourseCharpterList"
                          :props="treeProps"
                          :render-after-expand="false"
                      >
                          <div
                              class="custom-tree-node flex items-center"
                              slot-scope="{ node, data }"
                          >
                              <el-option
                                  :label="node.label"
                                  :value="data.id"
                              > </el-option>
                          </div>
                      </el-tree>
                  </el-select>
              </el-form-item>
<!--              <el-form-item label="用户">-->
<!--                  <el-input  v-model="queryForm.userId"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="应学习时长">-->
<!--                  <el-input  v-model="queryForm.shoudStudyTime"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="已学习时长">-->
<!--                  <el-input  v-model="queryForm.haveStudyTime"></el-input>-->
<!--              </el-form-item>-->
              <el-form-item label="是否学完">
<!--                  <el-input  v-model="queryForm.isFinished"></el-input>-->
                  <el-select style="width: 177px" v-model="queryForm.isFinished" placeholder="请选择" size="small">
                    <el-option :label="'是'" :value="1"></el-option>
                    <el-option :label="'否'" :value="0"></el-option>
                  </el-select>
              </el-form-item>
<!--              <el-form-item label="学习进度">-->
<!--                  <el-input  v-model="queryForm.studyProgress"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="最后学习时间">-->
<!--                  <el-input  v-model="queryForm.lastStudyTime"></el-input>-->
<!--              </el-form-item>-->
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getEduCourseCharpterStudyrecordList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
<!--        <el-button-->
<!--          type="primary"-->
<!--          size="small"-->
<!--          icon="el-icon-plus"-->
<!--          @click="addEduCourseCharpterStudyrecord"-->
<!--        >新建</el-button>-->
<!--        <el-button-->
<!--          type="warning"-->
<!--          plain-->
<!--          size="small"-->
<!--          icon="el-icon-edit"-->
<!--          :disabled="multipleSelection.length != 1"-->
<!--          @click="editEduCourseCharpterStudyrecord(null)"-->
<!--        >修改</el-button>-->
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteEduCourseCharpterStudyrecord(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshEduCourseCharpterStudyrecordList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="eduCourseCharpterStudyrecordList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="charpterId"
        label="章节"
        width="180"
      >
          <template slot-scope="scope">
              {{ scope.row.charpterId && scope.row.charpter ? scope.row.charpter.charpterName : '--' }}
          </template>
      </el-table-column>
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="userId"-->
<!--        label="用户"-->
<!--        width="180"-->
<!--      > </el-table-column>-->
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="shoudStudyTime"
        label="应学习时长"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="haveStudyTime"
        label="已学习时长"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="isFinished"
        label="是否学完"
        width="180"
      >
          <template slot-scope="scope">
              {{ scope.row.isFinished == 1 ? '是' : '否' }}
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="studyProgress"
        label="学习进度"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="lastStudyTime"
        label="最后学习时间"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkEduCourseCharpterStudyrecord(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
<!--            <div @click="editEduCourseCharpterStudyrecord(scop.row.id)">-->
<!--              <Icon size="16">-->
<!--                <Edit24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label">修改</span>-->
<!--            </div>-->
            <div @click="deleteEduCourseCharpterStudyrecord(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="eduCourseCharpterStudyrecordStates[eduCourseCharpterStudyrecordState]"
      :visible.sync="showDialog"
      width="60%"
      :append-to-body="true"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="eduCourseCharpterStudyrecord"
          ref="eduCourseCharpterStudyrecordForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="章节"
            prop="charpterId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="eduCourseCharpterStudyrecord.charpterId"-->
<!--              :disabled="eduCourseCharpterStudyrecordState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                  clearable
                  style="width: 177px"
                  v-model="eduCourseCharpterStudyrecord.charpterId"
                  placeholder="请选择"
                  :disabled="eduCourseCharpterStudyrecordState == 'check'"
                  size="small"
              >
                  <el-tree
                      :data="eduCourseCharpterList"
                      :props="treeProps"
                      :render-after-expand="false"
                  >
                      <div
                          class="custom-tree-node flex items-center"
                          slot-scope="{ node, data }"
                      >
                          <el-option
                              :label="node.label"
                              :value="data.id"
                          > </el-option>
                      </div>
                  </el-tree>
              </el-select>
          </el-form-item>
<!--          <el-form-item-->
<!--            label="用户"-->
<!--            prop="userId"-->
<!--          >-->
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="eduCourseCharpterStudyrecord.userId"-->
<!--              :disabled="eduCourseCharpterStudyrecordState == 'check'"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
          <el-form-item
            label="应学习时长"
            prop="shoudStudyTime"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="eduCourseCharpterStudyrecord.shoudStudyTime"
              :disabled="eduCourseCharpterStudyrecordState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="已学习时长"
            prop="haveStudyTime"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="eduCourseCharpterStudyrecord.haveStudyTime"
              :disabled="eduCourseCharpterStudyrecordState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="是否学完"
            prop="isFinished"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="eduCourseCharpterStudyrecord.isFinished"-->
<!--              :disabled="eduCourseCharpterStudyrecordState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                size="small"
                style="width: 177px"
                v-model="eduCourseCharpterStudyrecord.isFinished"
                :disabled="eduCourseCharpterStudyrecordState == 'check'"
              >
                  <el-option :label="'是'" :value="1"></el-option>
                  <el-option :label="'否'" :value="0"></el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="学习进度"
            prop="studyProgress"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="eduCourseCharpterStudyrecord.studyProgress"
              :disabled="eduCourseCharpterStudyrecordState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="最后学习时间"
            prop="lastStudyTime"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="eduCourseCharpterStudyrecord.lastStudyTime"
              :disabled="eduCourseCharpterStudyrecordState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="eduCourseCharpterStudyrecordState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetEduCourseCharpterStudyrecordList();
                    this.getEduCourseCharpterStudyrecordList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetEduCourseCharpterStudyrecordList();
                    this.getEduCourseCharpterStudyrecordList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     charpterId: '', //章节
                     userId: '', //用户
                     shoudStudyTime: '', //应学习时长
                     haveStudyTime: '', //已学习时长
                     isFinished: '', //是否学完
                     studyProgress: '', //学习进度
                     lastStudyTime: '', //最后学习时间
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                eduCourseCharpterStudyrecordState: 'add',
                eduCourseCharpterStudyrecordStates: {
                    add: '添加学习记录',
                    check: '查看学习记录',
                    edit: '修改学习记录'
                },

                multipleSelection: [],
                eduCourseCharpterStudyrecordList: [],
                eduCourseCharpterStudyrecord: {
                    id: '', //
                    charpterId: '', //章节
                    userId: '', //用户
                    shoudStudyTime: '', //应学习时长
                    haveStudyTime: '', //已学习时长
                    isFinished: '', //是否学完
                    studyProgress: '', //学习进度
                    lastStudyTime: '', //最后学习时间
                },
                btnLoading: false,

                rules: {
                    id: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    charpterId: [{ required: true, message: '章节不能为空', trigger: 'blur' }],
                    userId: [{ required: true, message: '用户不能为空', trigger: 'blur' }],
                    shoudStudyTime: [{ required: true, message: '应学习时长不能为空', trigger: 'blur' }],
                    haveStudyTime: [{ required: true, message: '已学习时长不能为空', trigger: 'blur' }],
                    isFinished: [{ required: true, message: '是否学完不能为空', trigger: 'blur' }],
                    studyProgress: [{ required: true, message: '学习进度不能为空', trigger: 'blur' }],
                    lastStudyTime: [{ required: true, message: '最后学习时间不能为空', trigger: 'blur' }],
                },
                courseId: '',
                eduCourseCharpterList: [],
                treeProps: {
                    children: 'children',
                    label: 'charpterName'
                },
            };
        },
        created() {

        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            resetEduCourseCharpterStudyrecordList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.eduCourseCharpterStudyrecordList = [];
            },
            init(id, sign){
                this.queryForm.userId = id;
                this.eduCourseCharpterStudyrecord.userId = id;
                this.courseId = sign;
                this.getZjList();
                this.getEduCourseCharpterStudyrecordList();
            },
            getZjList(){
                get(`/edu/coursecharpter/findAllAsTree`,{  courseId: this.courseId }).then((res) => {
                    if (res.success) {
                        this.eduCourseCharpterList = res.treeData;
                    }
                });
            },
            resetDialog() {
                this.eduCourseCharpterStudyrecordState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      charpterId: '', //章节
                      userId: this.queryForm.userId, //用户
                      shoudStudyTime: '', //应学习时长
                      haveStudyTime: '', //已学习时长
                      isFinished: '', //是否学完
                      studyProgress: '', //学习进度
                      lastStudyTime: '', //最后学习时间
                };
                this.getEduCourseCharpterStudyrecordList();
            },
            closeDialog() {
                this.showDialog = false
                this.eduCourseCharpterStudyrecord = {
                      id: '', //
                      charpterId: '', //章节
                      userId: this.eduCourseCharpterStudyrecord.userId, //用户
                      shoudStudyTime: '', //应学习时长
                      haveStudyTime: '', //已学习时长
                      isFinished: '', //是否学完
                      studyProgress: '', //学习进度
                      lastStudyTime: '', //最后学习时间
                };
            },
            submitForm() {
                if (this.eduCourseCharpterStudyrecordState == 'add') {
                    this.$refs.eduCourseCharpterStudyrecordForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/edu/coursecharpterstudyrecord/add`,{ ...this.eduCourseCharpterStudyrecord }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetEduCourseCharpterStudyrecordList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.eduCourseCharpterStudyrecordState == 'edit') {
                    this.$refs.eduCourseCharpterStudyrecordForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/edu/coursecharpterstudyrecord/edit`,{ ...this.eduCourseCharpterStudyrecord }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetEduCourseCharpterStudyrecordList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addEduCourseCharpterStudyrecord() {
                this.showDialog = true;
                this.eduCourseCharpterStudyrecordState = 'add';
            },
            checkEduCourseCharpterStudyrecord(eduCourseCharpterStudyrecordId) {
                console.log(eduCourseCharpterStudyrecordId);
                this.currentEduCourseCharpterStudyrecordId = eduCourseCharpterStudyrecordId;

                this.getEduCourseCharpterStudyrecordById();
                this.showDialog = true;
                this.eduCourseCharpterStudyrecordState = 'check';
            },
            editEduCourseCharpterStudyrecord(eduCourseCharpterStudyrecordId) {
                console.log('eduCourseCharpterStudyrecord', eduCourseCharpterStudyrecordId);
                if (eduCourseCharpterStudyrecordId) {
                    this.currentEduCourseCharpterStudyrecordId = eduCourseCharpterStudyrecordId;
                    this.getEduCourseCharpterStudyrecordById();
                } else {
                    this.eduCourseCharpterStudyrecord = { ...this.eduCourseCharpterStudyrecord, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.eduCourseCharpterStudyrecordState = 'edit';
            },
            deleteEduCourseCharpterStudyrecord(eduCourseCharpterStudyrecordId) {
                let ids = '';
                if (eduCourseCharpterStudyrecordId) {
                    ids = eduCourseCharpterStudyrecordId;
                } else {
                    ids = this.multipleSelection.map((eduCourseCharpterStudyrecord) => eduCourseCharpterStudyrecord.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/edu/coursecharpterstudyrecord/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetEduCourseCharpterStudyrecordList();
                                this.getEduCourseCharpterStudyrecordList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshEduCourseCharpterStudyrecordList() {
                this.resetEduCourseCharpterStudyrecordList();
                this.getEduCourseCharpterStudyrecordList();
            },
            getEduCourseCharpterStudyrecordList(query = {}) {
                this.loading = true;
                get(`/edu/coursecharpterstudyrecord/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.eduCourseCharpterStudyrecordList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getEduCourseCharpterStudyrecordById() {
                get(`/edu/coursecharpterstudyrecord/get`,{ id: this.currentEduCourseCharpterStudyrecordId }).then((res) =>{
                    if(res.success){
                      this.eduCourseCharpterStudyrecord = { ...this.eduCourseCharpterStudyrecord, ...res.eduCourseCharpterStudyrecord };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportEduCourseCharpterStudyrecordList() {
                //this.btnLoading = true;
                exprotExcel(`/edu/coursecharpterstudyrecord/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/edu/coursecharpterstudyrecord/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/edu/coursecharpterstudyrecord/importData`,formData);
              this.refreshEduCourseCharpterStudyrecordList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getEduCourseCharpterStudyrecordList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getEduCourseCharpterStudyrecordList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>